
  import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
  import { Validations } from 'vuelidate-property-decorators';
  import { required, minValue, maxLength } from 'vuelidate/lib/validators';
  import {
    EnumModel,
    JobItemType,
    JobItemTypeEnums,
    JobItemTypeEnumsGeneric,
    EnumModelGeneric
  } from '@/common/enumerations';
  import * as StringUtils from '@/utilities/string.utils';
  import { Client, EmployeeModel, EmployeeCreateModel } from '@/services/api.service';
  import toJobItemTypeFormatter from '@/filters/jobitemtype.formatter';
  import { EventBus } from '@/event-bus';
  import { EmployeeCreatedMessage } from '@/services/eventbus.models';

  @Component({
    filters: {
      toJobItemType: toJobItemTypeFormatter
    }
  })
  export default class EmployeeCreate extends Vue {
    private firstName: string = '';
    private lastName: string = '';
    private availableJobItemTypes: Array<EnumModelGeneric<JobItemType>> = [];
    private selectedJobItemTypes: Array<EnumModelGeneric<JobItemType>> = [];

    public formIsValid: boolean | null = null;
    public saveInProgress: boolean = false;
    @Validations()
    private validations = {
      firstName: { required },
      lastName: { required }
    };

    private mounted() {
      this.availableJobItemTypes.push(
        ...JobItemTypeEnumsGeneric.sort((n1, n2) => StringUtils.stringCompare(n1.name || '', n2.name || ''))
      );
    }

    private createEmployee() {
      // Do the work here
      // Run the validation
      // @ts-ignore
      this.saveInProgress = true;
      this.$v.$touch();
      const me = this;
      // @ts-ignore
      if (me.$v.$invalid) {
        this.formIsValid = false;
        console.log('Submit failed. Form is invalid.');
        this.saveInProgress = false;
      } else {
        // do your submit logic here
        me.formIsValid = true;
        console.log('Submit started. Form valid.');
        const newEmployee: EmployeeCreateModel = new EmployeeCreateModel();

        console.log(this.selectedJobItemTypes);
        newEmployee.init({
          firstName: this.firstName,
          lastName: this.lastName,
          assignableJobItemTypes: this.selectedJobItemTypes,
          isDeleted: false
        });
        console.log(newEmployee);
        const clientService: Client = new Client(process.env.VUE_APP_API_URL, this.$http);
        // @ts-ignore
        me.$Progress.start();
        clientService.createEmployee(newEmployee).then((data: EmployeeModel) => {
          // Route to the edit job list screen?
          console.log('Returned employee:');
          console.log(data);
          // @ts-ignore
          me.$Progress.finish();
          // @ts-ignore
          me.$awn.success('Employee ' + me.firstName + ' ' + me.lastName + ' created successfully');
          me.$emit('employee-created', data);
          EventBus.$emit('employee-created', new EmployeeCreatedMessage(data));
          me.closeModal();
        });
      }
    }
    private cancelEdit() {
      console.log('Cancelling edit...');
      // this.$emit('close');
      this.closeModal();
    }

    private closeModal() {
      this.$modal.hide('modal-employee-create');
    }
  }
